import * as React from "react";
const VisitActive = () => (
	<svg width="15" height="10" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.62695 2.73494L3.80428 4.91237L7.62695 1.08984" stroke="white" stroke-linecap="square" stroke-linejoin="round" />
	</svg>
);
export default VisitActive;
